import { anyType } from "../../types";

export const formatTobus = (features: {
    [key: string]: maplibregl.MapGeoJSONFeature[];
} | undefined) => {
    if (!features) { return features; }

    const newFeatures = { ...features };

    const busFeatureKey = Object.keys(newFeatures).find(key => key.includes('バス停（自主運行）＆時刻表'));

    const demandYaizuFeatureKey = Object.keys(newFeatures).find(key => key.includes('焼津インターチェンジ地区') && !key.includes('（乗降区域）'));
    const demandOoshimaFeatureKey = Object.keys(newFeatures).find(key => key.includes('大島・三和地区'));
    const demandOoiFeatureKey = Object.keys(newFeatures).find(key => key.includes('大井川地区') && !key.includes('（乗降区域）'));

    let busFeatures = busFeatureKey ? newFeatures[busFeatureKey] : undefined;
    const demandYaizuFeatures = demandYaizuFeatureKey ? newFeatures[demandYaizuFeatureKey] : undefined;
    const demandOoshimaFeatures = demandOoshimaFeatureKey ? newFeatures[demandOoshimaFeatureKey] : undefined;
    const demandOoiFeatures = demandOoiFeatureKey ? newFeatures[demandOoiFeatureKey] : undefined;

    // ============ デマンドタクシー ============
    if (demandYaizuFeatures && demandYaizuFeatureKey) {
        const newDemandYaizuFeatures = demandYaizuFeatures.map(feature => {
            const headerA = [];
            const properties: {[key: string]: string | string[][]} = {
                '利用方法': 'https://www.city.yaizu.lg.jp/documents/19134/yaizuic_norikata.pdf',
                ...Object.keys(feature.properties)
                    .filter(key => !key.includes('方面') && !key.includes('便') && !key.includes('予約締め切り時間'))
                    .reduce((obj: { [key: string]: anyType }, key) => {
                        obj[key] = feature.properties[key];
                        return obj;
                    }, {})
            };

            if(Object.keys(feature.properties).length === 0) { return feature; }

            // keyに 方面 を含むvalueを配列化
            const bin1Keys = Object.keys(feature.properties).filter(key => key.includes('便') && !key.includes('予約締め切り時間'));
            const bin1Values = bin1Keys.map(key => feature.properties[key]);
            const bin1yoyakuKeys = Object.keys(feature.properties).filter(key => key.includes('予約締め切り時間'));
            const bin1yoyakuValues = bin1yoyakuKeys.map(key => feature.properties[key]);
            headerA.push(' ');
            if (bin1Values.length > 0) { headerA.push('便'); }
            if (bin1yoyakuValues.length > 0) { headerA.push('予約締め切り時間'); }
            if (headerA.length > 0) {
                const combinedValuesA = bin1Values.map((value, index) => [`${index + 1}便`, value, bin1yoyakuValues[index]]);
                properties[''] = [headerA, ...combinedValuesA];
            }

            feature.properties = properties;
            return feature;
        });
        newFeatures[demandYaizuFeatureKey] = newDemandYaizuFeatures;
    }

    if (demandOoshimaFeatures && demandOoshimaFeatureKey) {
        const newDemandOoshimaFeatures = demandOoshimaFeatures.map(feature => {
            const headerA = [];
            const properties: {[key: string]: string | string[][]} = {
                '利用方法': 'https://www.city.yaizu.lg.jp/documents/19164/ohjima_demand.pdf',
                ...Object.keys(feature.properties)
                    .filter(key => !key.includes('方面') && !key.includes('便') && !key.includes('予約締め切り時間'))
                    .reduce((obj: { [key: string]: anyType }, key) => {
                        obj[key] = feature.properties[key];
                        return obj;
                    }, {})
            };

            if(Object.keys(feature.properties).length === 0) { return feature; }

            // keyに 方面 を含むvalueを配列化
            const bin1Keys = Object.keys(feature.properties).filter(key => key.includes('便') && !key.includes('予約締め切り時間'));
            const bin1Values = bin1Keys.map(key => feature.properties[key]);
            const bin1yoyakuKeys = Object.keys(feature.properties).filter(key => key.includes('便') && key.includes('予約締め切り時間'));
            const bin1yoyakuValues = bin1yoyakuKeys.map(key => feature.properties[key]);
            headerA.push(' ');
            if (bin1Values.length > 0) { headerA.push('便'); }
            if (bin1yoyakuValues.length > 0) { headerA.push('予約締め切り時間'); }
            if (headerA.length > 0) {
                const combinedValuesA = bin1Values.map((value, index) => [`${index + 1}便`, value, bin1yoyakuValues[index]]);
                properties[''] = [headerA, ...combinedValuesA];
            }
            
            feature.properties = properties;
            return feature;
        });
        newFeatures[demandOoshimaFeatureKey] = newDemandOoshimaFeatures;
    }

    if (demandOoiFeatures && demandOoiFeatureKey) {
        const newDemandOoiFeatures = demandOoiFeatures.map(feature => {
            const headerA = [];
            const headerB = [];
            const properties: {[key: string]: string | string[][]} = {
                '利用方法': 'https://www.city.yaizu.lg.jp/documents/13627/20251014145822.pdf',
                ...Object.keys(feature.properties)
                    .filter(key => !key.includes('方面'))
                    .reduce((obj: { [key: string]: anyType }, key) => {
                        obj[key] = feature.properties[key];
                        return obj;
                    }, {})
            };

            if(Object.keys(feature.properties).length === 0) { return feature; }

            // keyに 方面 を含むvalueを配列化
            const bin1Keys = Object.keys(feature.properties).filter(key => key.includes('方面_1_') && !key.includes('_土曜日運行'));
            const bin1Values = bin1Keys.map(key => feature.properties[key]);
            const bin1yoyakuKeys = Object.keys(feature.properties).filter(key => key.includes('方面_1_') && key.includes('_土曜日運行'));
            const bin1yoyakuValues = bin1yoyakuKeys.map(key => feature.properties[key]);
            headerA.push(' ');
            if (bin1Values.length > 0) { headerA.push('便'); }
            if (bin1yoyakuValues.length > 0) { headerA.push('土曜日運行'); }
            if (headerA.length > 0) {
                const combinedValuesA = bin1Values.map((value, index) => [`${index + 1}便`, value, bin1yoyakuValues[index]]);
                properties[feature.properties['方面_1']] = [headerA, ...combinedValuesA];
            }

            // keyに 方面_2_ を含むvalueを配列化
            const bin2Keys = Object.keys(feature.properties).filter(key => key.includes('方面_2_') && !key.includes('_土曜日運行'));
            const bin2Values = bin2Keys.map(key => feature.properties[key]);
            const bin2yoyakuKeys = Object.keys(feature.properties).filter(key => key.includes('方面_2_') && key.includes('_土曜日運行'));
            const bin2yoyakuValues = bin2yoyakuKeys.map(key => feature.properties[key]);
            headerB.push(' ');
            if (bin2Values.length > 0) { headerB.push('便'); }
            if (bin2yoyakuValues.length > 0) { headerB.push('土曜日運行'); }
            if (headerA.length > 0) {
                const combinedValuesB = bin2Values.map((value, index) => [`${index + 1}便`, value, bin2yoyakuValues[index]]);
                properties[feature.properties['方面_2']] = [headerB, ...combinedValuesB];
            }
            
            feature.properties = properties;
            return feature;
        });
        newFeatures[demandOoiFeatureKey] = newDemandOoiFeatures;
    }

    // ============ バス ============
    if (busFeatures) {
        busFeatures = busFeatures.map(feature => {
            const headerA = [];
            const headerB = [];
            const properties = Object.keys(feature.properties)
                .filter(key =>
                    !key.includes('A_平日便') &&
                    !key.includes('A_土曜・日曜・祝日便') &&
                    !key.includes('B_平日便') &&
                    !key.includes('B_土曜・日曜・祝日便')
                )
                .reduce((obj: { [key: string]: anyType }, key) => {
                    obj[key] = feature.properties[key];
                    return obj;
                }, {});

            // keyに平日便 または 土曜・日曜・祝日便 を含むvalueを配列化
            const aHeijitsuKeys = Object.keys(feature.properties).filter(key => key.includes('A_平日便'));
            const aHeijitsuValues = aHeijitsuKeys.map(key => feature.properties[key]);
            const aKyujitsuKeys = Object.keys(feature.properties).filter(key => key.includes('A_土曜・日曜・祝日便'));
            const aKyujitsuValues = aKyujitsuKeys.map(key => feature.properties[key]);
            if (aHeijitsuValues.length > 0) { headerA.push('A_平日便'); }
            if (aKyujitsuValues.length > 0) { headerA.push('A_土曜・日曜・祝日便'); }
            if (headerA.length > 0) {
                const combinedValuesA = aHeijitsuValues.map((value, index) => [value, aKyujitsuValues[index]]);
                properties['時刻表A'] = [headerA, ...combinedValuesA];
            }

            const bHeijitsuKeys = Object.keys(feature.properties).filter(key => key.includes('B_平日便'));
            const bHeijitsuValues = bHeijitsuKeys.map(key => feature.properties[key]);
            const bKyujitsuKeys = Object.keys(feature.properties).filter(key => key.includes('B_土曜・日曜・祝日便'));
            const bKyujitsuValues = bKyujitsuKeys.map(key => feature.properties[key]);
            if (bHeijitsuValues.length > 0) { headerB.push('B_平日便'); }
            if (bKyujitsuValues.length > 0) { headerB.push('B_土曜・日曜・祝日便'); }
            if (headerB.length > 0) {
                const combinedValuesB = bHeijitsuValues.map((value, index) => [value, bKyujitsuValues[index]]);
                properties['時刻表B'] = [headerB, ...combinedValuesB];
            }

            feature.properties = properties;

            return feature;
        });
        newFeatures['バス停（自主運行）＆時刻表'] = busFeatures;
    }

    return newFeatures;
}
